module.exports = {
	previousMonth : 'Previous Month',
	nextMonth     : 'Next Month',
	months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
	weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	weekdaysShort : ['S','M','T','W','T','F','S']
}